export const build = { date:"2026-06-04.1121", stage:"alpha" }
